// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cancellation-errorMessage-EqisI {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.Cancellation-space1-QhVlH {
	margin-bottom: 6px !important;
}
.Cancellation-space2-j3_PP {
	margin-bottom: 12px !important;
}
.Cancellation-space3-eOV_t {
	margin-bottom: 18px !important;
}
.Cancellation-space4-QSnmh {
	margin-bottom: 24px !important;
}
.Cancellation-space5-nYgXr {
	margin-bottom: 30px !important;
}
.Cancellation-space6-vCOhB {
	margin-bottom: 36px !important;
}
.Cancellation-space7-ZxWHg {
	margin-bottom: 42px !important;
}
.Cancellation-spaceTop8-wsbTm {
	margin-bottom: 48px !important;
}
.Cancellation-spaceTop1-UkWSE {
	margin-top: 6px !important;
}
.Cancellation-spaceTop2-i9Xtj {
	margin-top: 12px !important;
}
.Cancellation-spaceTop3-gcMRt {
	margin-top: 18px !important;
}
.Cancellation-spaceTop4-r5dPf {
	margin-top: 24px !important;
}
.Cancellation-spaceTop5-uXGr0 {
	margin-top: 30px !important;
}
.Cancellation-spaceTop6-rF17q {
	margin-top: 36px !important;
}
.Cancellation-spaceTop7-TPtJI {
	margin-top: 42px !important;
}
.Cancellation-spaceTop8-wsbTm {
	margin-top: 48px !important;
}
.Cancellation-noMargin-efhhi {
	margin: 0px !important;
}
.Cancellation-padding1-Jg8jt {
	padding-bottom: 6px !important;
}
.Cancellation-padding2-nIKB9 {
	padding-bottom: 12px !important;
}
.Cancellation-padding3-sdWIM {
	padding-bottom: 18px !important;
}
.Cancellation-padding4-gao4I {
	padding-bottom: 24px !important;
}
.Cancellation-padding5-FTuYR {
	padding-bottom: 30px !important;
}
.Cancellation-padding6-ZUXkU {
	padding-bottom: 36px !important;
}
.Cancellation-padding7-A1H5C {
	padding-bottom: 42px !important;
}
.Cancellation-paddingTop1-cGnA8 {
	padding-top: 6px !important;
}
.Cancellation-paddingTop2-_iMaz {
	padding-top: 12px !important;
}
.Cancellation-paddingTop3-HIEsv {
	padding-top: 18px !important;
}
.Cancellation-paddingTop4-SBgoz {
	padding-top: 24px !important;
}
.Cancellation-paddingTop5-dAkgV {
	padding-top: 30px !important;
}
.Cancellation-paddingTop6-RFUit {
	padding-top: 36px !important;
}
.Cancellation-paddingTop7-YVVFK {
	padding-top: 42px !important;
}
.Cancellation-noPadding-Ca26q {
	padding: 0px !important;
}
.Cancellation-textBold-p4rdc {
	font-weight: 500 !important;
}
.Cancellation-textBolder-lTHkf {
	font-weight: 700 !important;
}
.Cancellation-textNormal-AMWCw {
	font-weight: normal !important;
}
.Cancellation-spaceBottom20-bai8p {
	margin-bottom: 20px;
}
.Cancellation-spaceBottom10-H33VV {
	margin-bottom: 10px;
}
.Cancellation-marginNone-IN1EN {
	margin: 0;
}
.Cancellation-spaceBottom15-vFg5u {
	margin-bottom: 15px;
}
.Cancellation-marginTopNone-JqYAl {
	margin-top: 0;
}
.Cancellation-spaceTop11-JNlsj {
	margin-top: 11px;
}
.Cancellation-spaceTop21-VMPuh {
	margin-top: 21px;
}
.Cancellation-spaceTop20-nvs6C {
	margin-top: 20px;
}
.Cancellation-spaceTop10-Dmok_ {
	margin-top: 10px;
}
/*New Design Text Colors */
.Cancellation-textDarkBlue-dQdHS {
	color: rgb(20, 39, 94) !important;
}
.Cancellation-textLightBlue-y07nX {
	color: rgb(57, 87, 106) !important;
}
.Cancellation-textLightSandleGreen-UGpBM {
	color: rgb(76, 86, 41) !important;
}
.Cancellation-textLightBrown-w9QmI {
	color: rgb(115, 79, 33) !important;
}
.Cancellation-textMediumMaroon-sDEL9 {
	color: rgb(87, 37, 51) !important;
}
.Cancellation-textBrown-P8ogn {
	color: rgb(160, 47, 24) !important;
}
.Cancellation-textMaroon-E6ykm {
	color: rgb(155, 49, 67) !important;
}
.Cancellation-textDarkBrown-PwBfB {
	color: rgb(83, 18, 16) !important;
}
.Cancellation-textMediumBrown-qNMsV {
	color: rgb(142, 28, 10) !important;
}
.Cancellation-textSkyBlue-FUlc0 {
	color: rgb(37, 117, 141) !important;
}
.Cancellation-textGray-BhgQz {
	color: rgb(77, 65, 51) !important;
}
.Cancellation-landingContentTitle-Yowcf {
	font-size: 24px;
	font-weight: bold;
	margin-top: 0px;
}
.Cancellation-landingSubTitle-GexDD {
	font-size: 20px;
	font-weight: 600;
	color: var(--primary-foreground);
	margin: 0px;
}
.Cancellation-textHigh-SqHBn {
	font-size: 18px;
}
.Cancellation-textTruncate-ChL34 {
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.Cancellation-textLine-WYsxL {
	text-decoration: line-through;
	text-decoration-color: var(--alert-color);
}
.Cancellation-formGroup-EBeXm {
	margin-bottom: 6px;
}
.Cancellation-landingStep-EYk7O {
	font-size: 14px;
	line-height: 25px;
	color: var(--secondary-foreground);
	margin-bottom: 0;
}
.Cancellation-landingStepDesc-Di48x {
	font-size: 14px;
	color: var(--secondary-foreground);
}
.Cancellation-horizontalLineThrough-MdVT2 {
	position: relative;
	z-index: 1;
	display: block;
	margin: 30px 0px;
	width: 100%;
	text-align: center;
	font-size: 14px;
}
.Cancellation-profileAvatarLink-putbE {
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	display: inline-block;
	overflow: hidden;
	background-color: var(--secondary-gray-bg);
	border: 2px solid var(--primary-border);
	border-radius: 50%;
}
.Cancellation-cancelBg-NAGW9 {
	width: 100%;
	height: 100%;
	background-size: cover;
	background-color: var(--primary-border);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	border-top-right-radius: 15px;
	border-top-left-radius: 15px;
	padding-top: 53%;
}
.Cancellation-cancellation-lKHN5 {
	font-size: 14px;
	color: var(--secondary-foreground);
}
.Cancellation-greenColor-_rRmf {
	font-weight: bold;
	color: var(--secondary-bg) !important;
}
.Cancellation-displayGridDats-pQrIL {
	display: grid;
	grid-template-columns: 49% 49%;
	grid-gap: 12px;
}
.Cancellation-displayGridParent-D1OJ3 {
	display: grid;
	grid-template-columns: 57% 40%;
	grid-gap: 34px;
}
.Cancellation-datesTitle-q0iXE {
	font-size: 16px;
	font-weight: 500;
}
.Cancellation-datesValueText-OXl7Q {
	font-size: 16px;
	color: var(--secondary-foreground);
	margin: 0px;
}
.Cancellation-linkBtn-T4Xls {
	vertical-align: middle;
	border: 0px !important;
	padding: 0px !important;
	margin-right: 41px;
	color: var(--primary-link-foreground) !important;
	background: transparent !important;
}
.Cancellation-listDetailsSection-Zr6tv {
	border: 1px solid var(--primary-border);
	border-radius: 0px 0px 15px 15px;
	padding: 20px;
}
.Cancellation-listTitle-FembC {
	font-size: 18px;
	margin: 0px;
	color: var(--primary-foreground);
	text-decoration: none !important;
}
.Cancellation-listTitleDetails-LUXhh {
	font-size: 14px;
	color: var(--secondary-foreground);
	margin: 6px 0px 0px;
}
.Cancellation-starImage-KnZcv>svg {
	width: 12px;
	height: 12px;
	position: relative;
	top: -1px;
}
.Cancellation-starFlex-fs4q5 {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	color: var(--primary-foreground);
	font-size: 12px;
	margin: 0px 0px 6px;
	gap: 2px;
}
.Cancellation-reviewText-HzRQm {
	padding-left: 15px;
	position: relative;
}
.Cancellation-reviewText-HzRQm::before {
	content: '';
	width: 3px;
	height: 3px;
	position: absolute;
	left: 6px;
	border-radius: 50%;
	background-color: var(--primary-foreground);
	top: 6px;
}
.Cancellation-refundableBg-UL7Jq,
.Cancellation-refundableSuccessBg-N0nuL {
	padding: 20px 20px 20px;
	border-radius: 6px;
	margin-top: 18px;
}
.Cancellation-refundableText-DVrta {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 12px;
	color: var(--primary-foreground);
}
.Cancellation-refundableNoBorder-wP1Mb {
	border-bottom: none;
	padding-bottom: 0px;
	margin-bottom: 0px;
}
.Cancellation-displayFlexAvatar-jauoe {
	display: grid;
	grid-template-columns: 60px auto;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	margin-top: 18px;
	grid-column-gap: 15px;
	word-break: break-word;
}
.Cancellation-hostedText-zuvWu {
	margin: 0px;
	font-size: 18px;
	font-weight: 600;
}
.Cancellation-refundIconSec-d8bUE {
	position: relative;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
	gap: 12px;
}
.Cancellation-refundIconSec-d8bUE img {
	width: 22px;
	height: 22px;
}
.Cancellation-refundableBg-UL7Jq {
	background-color: var(--tertiary-gray-bg);
}
.Cancellation-refundableSuccessBg-N0nuL {
	background-color: var(--tertiary-gray-bg);
}
.Cancellation-cancelListDetail-BBFeu {
	text-decoration: none !important;
}
@media screen and (max-width: 767px) {
	.Cancellation-displayGridDats-pQrIL {
		grid-template-columns: 100%;
	}

	.Cancellation-linkBtn-T4Xls {
		margin-right: 0;
		margin-bottom: 18px;
		display: inline-block;
	}

	.Cancellation-refundIconSec-d8bUE {
		gap: 8px;
	}

	.Cancellation-textHigh-SqHBn {
		font-size: 16px;
	}

	.Cancellation-refundIconSec-d8bUE img {
		position: relative;
		top: 1px;
		width: 18px;
		height: 18px;
	}
}
@media screen and (max-width: 991px) {
	.Cancellation-displayGridParent-D1OJ3 {
		grid-template-columns: 100%;
		grid-gap: 34px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/Cancellation/Cancellation.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA;CACC,eAAe;CACf,iBAAiB;CACjB,eAAe;AAChB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gCAAgC;CAChC,WAAW;AACZ;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,uBAAuB;AACxB;AAEA;CACC,6BAA6B;CAC7B,yCAAyC;AAC1C;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,qBAAqB;CACrB,gBAAgB;CAChB,0CAA0C;CAC1C,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,uCAAuC;CACvC,4BAA4B;CAC5B,4BAA4B;CAC5B,6BAA6B;CAC7B,4BAA4B;CAC5B,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,iBAAiB;CACjB,qCAAqC;AACtC;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,cAAc;AACf;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,WAAW;AACZ;AAEA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,uBAAuB;CACvB,kBAAkB;CAClB,gDAAgD;CAChD,kCAAkC;AACnC;AAEA;CACC,uCAAuC;CACvC,gCAAgC;CAChC,aAAa;AACd;AAEA;CACC,eAAe;CACf,WAAW;CACX,gCAAgC;CAChC,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,gCAAgC;CAChC,eAAe;CACf,mBAAmB;CACnB,QAAQ;AACT;AAEA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,SAAS;CACT,kBAAkB;CAClB,2CAA2C;CAC3C,QAAQ;AACT;AAEA;;CAEC,uBAAuB;CACvB,kBAAkB;CAClB,gBAAgB;AACjB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,mBAAe;KAAf,eAAe;CACf,SAAS;CACT,gCAAgC;AACjC;AAEA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;AACV;AAEA;CACC,WAAW;CACX,YAAY;AACb;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,yCAAyC;AAC1C;AAEA;CACC,gCAAgC;AACjC;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,eAAe;EACf,mBAAmB;EACnB,qBAAqB;CACtB;;CAEA;EACC,QAAQ;CACT;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;CACb;AACD;AAEA;CACC;EACC,2BAA2B;EAC3B,cAAc;CACf;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n.landingContentTitle {\n\tfont-size: 24px;\n\tfont-weight: bold;\n\tmargin-top: 0px;\n}\n\n.landingSubTitle {\n\tfont-size: 20px;\n\tfont-weight: 600;\n\tcolor: var(--primary-foreground);\n\tmargin: 0px;\n}\n\n.textHigh {\n\tfont-size: 18px;\n}\n\n.textTruncate {\n\toverflow: hidden;\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n}\n\n.textLine {\n\ttext-decoration: line-through;\n\ttext-decoration-color: var(--alert-color);\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.landingStep {\n\tfont-size: 14px;\n\tline-height: 25px;\n\tcolor: var(--secondary-foreground);\n\tmargin-bottom: 0;\n}\n\n.landingStepDesc {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 30px 0px;\n\twidth: 100%;\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.profileAvatarLink {\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tdisplay: inline-block;\n\toverflow: hidden;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 2px solid var(--primary-border);\n\tborder-radius: 50%;\n}\n\n.cancelBg {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-size: cover;\n\tbackground-color: var(--primary-border);\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tborder-top-right-radius: 15px;\n\tborder-top-left-radius: 15px;\n\tpadding-top: 53%;\n}\n\n.cancellation {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n}\n\n.greenColor {\n\tfont-weight: bold;\n\tcolor: var(--secondary-bg) !important;\n}\n\n.displayGridDats {\n\tdisplay: grid;\n\tgrid-template-columns: 49% 49%;\n\tgrid-gap: 12px;\n}\n\n.displayGridParent {\n\tdisplay: grid;\n\tgrid-template-columns: 57% 40%;\n\tgrid-gap: 34px;\n}\n\n.datesTitle {\n\tfont-size: 16px;\n\tfont-weight: 500;\n}\n\n.datesValueText {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0px;\n}\n\n.linkBtn {\n\tvertical-align: middle;\n\tborder: 0px !important;\n\tpadding: 0px !important;\n\tmargin-right: 41px;\n\tcolor: var(--primary-link-foreground) !important;\n\tbackground: transparent !important;\n}\n\n.listDetailsSection {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px 0px 15px 15px;\n\tpadding: 20px;\n}\n\n.listTitle {\n\tfont-size: 18px;\n\tmargin: 0px;\n\tcolor: var(--primary-foreground);\n\ttext-decoration: none !important;\n}\n\n.listTitleDetails {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 6px 0px 0px;\n}\n\n.starImage>svg {\n\twidth: 12px;\n\theight: 12px;\n\tposition: relative;\n\ttop: -1px;\n}\n\n.starFlex {\n\tdisplay: flex;\n\tcolor: var(--primary-foreground);\n\tfont-size: 12px;\n\tmargin: 0px 0px 6px;\n\tgap: 2px;\n}\n\n.reviewText {\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.reviewText::before {\n\tcontent: '';\n\twidth: 3px;\n\theight: 3px;\n\tposition: absolute;\n\tleft: 6px;\n\tborder-radius: 50%;\n\tbackground-color: var(--primary-foreground);\n\ttop: 6px;\n}\n\n.refundableBg,\n.refundableSuccessBg {\n\tpadding: 20px 20px 20px;\n\tborder-radius: 6px;\n\tmargin-top: 18px;\n}\n\n.refundableText {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tflex-wrap: wrap;\n\tgap: 12px;\n\tcolor: var(--primary-foreground);\n}\n\n.refundableNoBorder {\n\tborder-bottom: none;\n\tpadding-bottom: 0px;\n\tmargin-bottom: 0px;\n}\n\n.displayFlexAvatar {\n\tdisplay: grid;\n\tgrid-template-columns: 60px auto;\n\talign-items: center;\n\tmargin-top: 18px;\n\tgrid-column-gap: 15px;\n\tword-break: break-word;\n}\n\n.hostedText {\n\tmargin: 0px;\n\tfont-size: 18px;\n\tfont-weight: 600;\n}\n\n.refundIconSec {\n\tposition: relative;\n\tdisplay: flex;\n\talign-items: flex-start;\n\tgap: 12px;\n}\n\n.refundIconSec img {\n\twidth: 22px;\n\theight: 22px;\n}\n\n.refundableBg {\n\tbackground-color: var(--tertiary-gray-bg);\n}\n\n.refundableSuccessBg {\n\tbackground-color: var(--tertiary-gray-bg);\n}\n\n.cancelListDetail {\n\ttext-decoration: none !important;\n}\n\n@media screen and (max-width: 767px) {\n\t.displayGridDats {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.linkBtn {\n\t\tmargin-right: 0;\n\t\tmargin-bottom: 18px;\n\t\tdisplay: inline-block;\n\t}\n\n\t.refundIconSec {\n\t\tgap: 8px;\n\t}\n\n\t.textHigh {\n\t\tfont-size: 16px;\n\t}\n\n\t.refundIconSec img {\n\t\tposition: relative;\n\t\ttop: 1px;\n\t\twidth: 18px;\n\t\theight: 18px;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.displayGridParent {\n\t\tgrid-template-columns: 100%;\n\t\tgrid-gap: 34px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `Cancellation-errorMessage-EqisI`,
	"space1": `Cancellation-space1-QhVlH`,
	"space2": `Cancellation-space2-j3_PP`,
	"space3": `Cancellation-space3-eOV_t`,
	"space4": `Cancellation-space4-QSnmh`,
	"space5": `Cancellation-space5-nYgXr`,
	"space6": `Cancellation-space6-vCOhB`,
	"space7": `Cancellation-space7-ZxWHg`,
	"spaceTop8": `Cancellation-spaceTop8-wsbTm`,
	"spaceTop1": `Cancellation-spaceTop1-UkWSE`,
	"spaceTop2": `Cancellation-spaceTop2-i9Xtj`,
	"spaceTop3": `Cancellation-spaceTop3-gcMRt`,
	"spaceTop4": `Cancellation-spaceTop4-r5dPf`,
	"spaceTop5": `Cancellation-spaceTop5-uXGr0`,
	"spaceTop6": `Cancellation-spaceTop6-rF17q`,
	"spaceTop7": `Cancellation-spaceTop7-TPtJI`,
	"noMargin": `Cancellation-noMargin-efhhi`,
	"padding1": `Cancellation-padding1-Jg8jt`,
	"padding2": `Cancellation-padding2-nIKB9`,
	"padding3": `Cancellation-padding3-sdWIM`,
	"padding4": `Cancellation-padding4-gao4I`,
	"padding5": `Cancellation-padding5-FTuYR`,
	"padding6": `Cancellation-padding6-ZUXkU`,
	"padding7": `Cancellation-padding7-A1H5C`,
	"paddingTop1": `Cancellation-paddingTop1-cGnA8`,
	"paddingTop2": `Cancellation-paddingTop2-_iMaz`,
	"paddingTop3": `Cancellation-paddingTop3-HIEsv`,
	"paddingTop4": `Cancellation-paddingTop4-SBgoz`,
	"paddingTop5": `Cancellation-paddingTop5-dAkgV`,
	"paddingTop6": `Cancellation-paddingTop6-RFUit`,
	"paddingTop7": `Cancellation-paddingTop7-YVVFK`,
	"noPadding": `Cancellation-noPadding-Ca26q`,
	"textBold": `Cancellation-textBold-p4rdc`,
	"textBolder": `Cancellation-textBolder-lTHkf`,
	"textNormal": `Cancellation-textNormal-AMWCw`,
	"spaceBottom20": `Cancellation-spaceBottom20-bai8p`,
	"spaceBottom10": `Cancellation-spaceBottom10-H33VV`,
	"marginNone": `Cancellation-marginNone-IN1EN`,
	"spaceBottom15": `Cancellation-spaceBottom15-vFg5u`,
	"marginTopNone": `Cancellation-marginTopNone-JqYAl`,
	"spaceTop11": `Cancellation-spaceTop11-JNlsj`,
	"spaceTop21": `Cancellation-spaceTop21-VMPuh`,
	"spaceTop20": `Cancellation-spaceTop20-nvs6C`,
	"spaceTop10": `Cancellation-spaceTop10-Dmok_`,
	"textDarkBlue": `Cancellation-textDarkBlue-dQdHS`,
	"textLightBlue": `Cancellation-textLightBlue-y07nX`,
	"textLightSandleGreen": `Cancellation-textLightSandleGreen-UGpBM`,
	"textLightBrown": `Cancellation-textLightBrown-w9QmI`,
	"textMediumMaroon": `Cancellation-textMediumMaroon-sDEL9`,
	"textBrown": `Cancellation-textBrown-P8ogn`,
	"textMaroon": `Cancellation-textMaroon-E6ykm`,
	"textDarkBrown": `Cancellation-textDarkBrown-PwBfB`,
	"textMediumBrown": `Cancellation-textMediumBrown-qNMsV`,
	"textSkyBlue": `Cancellation-textSkyBlue-FUlc0`,
	"textGray": `Cancellation-textGray-BhgQz`,
	"landingContentTitle": `Cancellation-landingContentTitle-Yowcf`,
	"landingSubTitle": `Cancellation-landingSubTitle-GexDD`,
	"textHigh": `Cancellation-textHigh-SqHBn`,
	"textTruncate": `Cancellation-textTruncate-ChL34`,
	"textLine": `Cancellation-textLine-WYsxL`,
	"formGroup": `Cancellation-formGroup-EBeXm`,
	"landingStep": `Cancellation-landingStep-EYk7O`,
	"landingStepDesc": `Cancellation-landingStepDesc-Di48x`,
	"horizontalLineThrough": `Cancellation-horizontalLineThrough-MdVT2`,
	"profileAvatarLink": `Cancellation-profileAvatarLink-putbE`,
	"cancelBg": `Cancellation-cancelBg-NAGW9`,
	"cancellation": `Cancellation-cancellation-lKHN5`,
	"greenColor": `Cancellation-greenColor-_rRmf`,
	"displayGridDats": `Cancellation-displayGridDats-pQrIL`,
	"displayGridParent": `Cancellation-displayGridParent-D1OJ3`,
	"datesTitle": `Cancellation-datesTitle-q0iXE`,
	"datesValueText": `Cancellation-datesValueText-OXl7Q`,
	"linkBtn": `Cancellation-linkBtn-T4Xls`,
	"listDetailsSection": `Cancellation-listDetailsSection-Zr6tv`,
	"listTitle": `Cancellation-listTitle-FembC`,
	"listTitleDetails": `Cancellation-listTitleDetails-LUXhh`,
	"starImage": `Cancellation-starImage-KnZcv`,
	"starFlex": `Cancellation-starFlex-fs4q5`,
	"reviewText": `Cancellation-reviewText-HzRQm`,
	"refundableBg": `Cancellation-refundableBg-UL7Jq`,
	"refundableSuccessBg": `Cancellation-refundableSuccessBg-N0nuL`,
	"refundableText": `Cancellation-refundableText-DVrta`,
	"refundableNoBorder": `Cancellation-refundableNoBorder-wP1Mb`,
	"displayFlexAvatar": `Cancellation-displayFlexAvatar-jauoe`,
	"hostedText": `Cancellation-hostedText-zuvWu`,
	"refundIconSec": `Cancellation-refundIconSec-d8bUE`,
	"cancelListDetail": `Cancellation-cancelListDetail-BBFeu`
};
module.exports = ___CSS_LOADER_EXPORT___;
